import React, { memo, useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import RfqNoteDialog from "./RfqNoteDialog";
import { rememberLastWorkQueueRfq } from "../../utils/purchaseOrderWorkQueue";

function rfqNoteFirstLine(note: string | null | undefined): string {
  if (!note?.trim()) {
    return "";
  }
  return note.split(/\r?\n/)[0]?.trim() ?? "";
}

interface RfqNoteCellProps {
  rfqId: number;
  rfqReferenceNum: string;
  note: string | null;
}

const RfqNoteCell: React.FC<RfqNoteCellProps> = ({
  rfqId,
  rfqReferenceNum,
  note,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const firstLine = rfqNoteFirstLine(note);
  const hasNote = firstLine.length > 0;

  const openDialog = (e: React.MouseEvent) => {
    e.stopPropagation();
    rememberLastWorkQueueRfq(rfqId);
    setDialogOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          width: "100%",
          minWidth: 0,
        }}
      >
        {hasNote ? (
          <Tooltip title={note ?? ""} placement="top" enterDelay={500}>
            <Typography
              component="button"
              type="button"
              onClick={openDialog}
              sx={{
                border: "none",
                background: "none",
                padding: 0,
                margin: 0,
                font: "inherit",
                cursor: "pointer",
                textAlign: "left",
                width: "100%",
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                color: "text.primary",
              }}
            >
              {firstLine}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            component="button"
            type="button"
            onClick={openDialog}
            sx={{
              border: "none",
              background: "none",
              padding: 0,
              margin: 0,
              font: "inherit",
              fontStyle: "italic",
              color: grey[400],
              cursor: "pointer",
              textAlign: "left",
            }}
          >
            Click to add note
          </Typography>
        )}
      </Box>
      {dialogOpen ? (
        <RfqNoteDialog
          open={dialogOpen}
          rfqId={rfqId}
          rfqReferenceNum={rfqReferenceNum}
          initialNote={note ?? ""}
          onClose={() => setDialogOpen(false)}
        />
      ) : null}
    </>
  );
};

export default memo(RfqNoteCell);
